module.exports = __webpack_public_path__ + "img/logo1.266e49f3.png";